import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { baseURL } from 'app/client';
import { GenericLoading } from 'components/ui/Loader';
import { XCircle } from 'lucide-react';

interface CreateSessionFromTokenResponse {
  isSuccess: boolean;
  signatureUrl?: string;
  redirectFormHtml?: string;
  errorMessage?: string;
  errorCode?: string;
}

const MandateSignatureCallback: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleMandateSignature = async () => {
      if (!token) {
        setError('Lien invalide.');
        return;
      }

      try {
        const response = await fetch(
          `${baseURL}/api/backoffice/epithete/session/${token}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );

        if (!response.ok) {
          throw new Error('Une erreur est survenue. Veuillez réessayer.');
        }

        const result: CreateSessionFromTokenResponse = await response.json();

        if (result.isSuccess && result.signatureUrl) {
          window.location.href = result.signatureUrl;
          return;
        }

        setError(result.errorMessage || 'Une erreur est survenue. Veuillez réessayer.');
      } catch (err) {
        const message = err instanceof Error ? err.message : 'Une erreur est survenue. Veuillez réessayer.';
        setError(message);
      }
    };

    handleMandateSignature();
  }, [token]);

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-red-50 via-white to-primary/5 flex items-center justify-center p-4">
        <div className="max-w-md w-full">
          <div className="bg-white rounded-2xl shadow-xl p-8">
            <div className="flex justify-center mb-6">
              <div className="bg-red-50 rounded-full p-4">
                <XCircle className="w-16 h-16 text-red-500" strokeWidth={2} />
              </div>
            </div>

            <h1 className="text-2xl font-bold text-center text-gray-800 mb-4">
              Signature impossible
            </h1>

            <div className="bg-red-50 border-l-4 border-red-500 rounded-r-lg p-4 mb-6">
              <p className="text-gray-700 text-center leading-relaxed">
                {error}
              </p>
            </div>

            <button
              onClick={() => window.location.href = '/'}
              className="w-full bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary text-white font-semibold py-3 px-6 rounded-lg transition-all duration-300"
            >
              Retour à l'accueil
            </button>
          </div>
        </div>
      </div>
    );
  }

  return <GenericLoading loading isFullPage />;
};

export default MandateSignatureCallback;
